import axios from "axios";
import React, {
  useEffect,
  useState,
  useContext,
  Fragment,
  useMemo,
} from "react";
import { Link } from "react-router-dom";
import UserDataContext from "../../context/UserDataContext";
import { MRT_Localization_DE } from "material-react-table/locales/de";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { translate } from "../../translations";

export default function ServiceList() {
  const [services, setServices] = useState([]);
  const [activatedFields, setActivatedFields] = useState([]);
  const { userData } = useContext(UserDataContext);
  const token = localStorage.getItem("token");
  const project = localStorage.getItem("currentProjectID");

  async function getServices() {
    let activatedFieldsQuery = await axios.get(
      `${process.env.REACT_APP_BACKEND}/settings/editServices/${project}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );

    activatedFieldsQuery.data["0"].value.activatedFields.push("_id");

    const userRes = await axios.get(
      `${process.env.REACT_APP_BACKEND}/services/list/${project}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );
    const mappedUserRes = userRes.data.map((record) => ({
      ...record,
      mappedKostenstelle: record.kostenstelle ? record.kostenstelle.name : "",
      mappedWerkStandort: record.werk_standort ? record.werk_standort.name : "",
      mappedFachbereich: record.fachbereich ? record.fachbereich.name : "",
      mappedAbteilung: record.abteilung ? record.abteilung.name : "",
      mappedGebaeude: record.gebaeude ? record.gebaeude.name : "",
      mappedEtage: record.etage ? record.etage.name : "",
      mappedAnlage: record.anlage ? record.anlage.name : "",
      mappedMengeneinheit: record.mengeneinheit
        ? record.mengeneinheit.name
        : "",
    }));

    setServices(mappedUserRes);

    if (
      userData &&
      userData.permissions &&
      !userData.permissions[project].isProjectAdmin
    ) {
      setServices(
        mappedUserRes.filter((service) =>
          userData.permissions[project].kostenstellen.includes(
            service.kostenstelle._id
          )
        )
      );
    }

    if (
      activatedFieldsQuery.data["0"].value.activatedFields.includes(
        "mengeneinheit"
      )
    ) {
      activatedFieldsQuery.data["0"].value.activatedFields.push(
        "mappedMengeneinheit"
      );
    }
    if (
      activatedFieldsQuery.data["0"].value.activatedFields.includes("anlage")
    ) {
      activatedFieldsQuery.data["0"].value.activatedFields.push("mappedAnlage");
    }
    if (
      activatedFieldsQuery.data["0"].value.activatedFields.includes("etage")
    ) {
      activatedFieldsQuery.data["0"].value.activatedFields.push("mappedEtage");
    }
    if (
      activatedFieldsQuery.data["0"].value.activatedFields.includes("abteilung")
    ) {
      activatedFieldsQuery.data["0"].value.activatedFields.push(
        "mappedAbteilung"
      );
    }
    if (
      activatedFieldsQuery.data["0"].value.activatedFields.includes("gebaeude")
    ) {
      activatedFieldsQuery.data["0"].value.activatedFields.push(
        "mappedGebaeude"
      );
    }
    if (
      activatedFieldsQuery.data["0"].value.activatedFields.includes(
        "fachbereich"
      )
    ) {
      activatedFieldsQuery.data["0"].value.activatedFields.push(
        "mappedFachbereich"
      );
    }

    if (
      activatedFieldsQuery.data["0"].value.activatedFields.includes(
        "fachbereich"
      )
    ) {
      activatedFieldsQuery.data["0"].value.activatedFields.push(
        "mappedFachbereich"
      );
    }

    if (
      activatedFieldsQuery.data["0"].value.activatedFields.includes(
        "kostenstelle"
      )
    ) {
      activatedFieldsQuery.data["0"].value.activatedFields.push(
        "mappedKostenstelle"
      );
    }

    if (
      activatedFieldsQuery.data["0"].value.activatedFields.includes(
        "werk_standort"
      )
    ) {
      activatedFieldsQuery.data["0"].value.activatedFields.push(
        "mappedWerkStandort"
      );
    }

    setActivatedFields(activatedFieldsQuery.data["0"].value.activatedFields);
  }

  let allColumns = [
    {
      accessorKey: "mappedWerkStandort",
      header: translate("werk_standort"),
    },
    {
      accessorKey: "mappedFachbereich",
      header: translate("fachbereich"),
    },
    {
      accessorKey: "mappedAbteilung",
      header: translate("abteilung"),
    },
    {
      accessorKey: "mappedGebaeude",
      header: translate("gebaeude"),
    },
    {
      accessorKey: "mappedEtage",
      header: translate("etage"),
    },
    {
      accessorKey: "mappedAnlage",
      header: translate("anlage"),
    },
    {
      accessorKey: "pos_nr",
      header: translate("pos_nr"),
    },
    {
      accessorKey: "pos_name",
      header: translate("pos_name"),
    },
    {
      accessorKey: "leistungsbeschreibung_kurz",
      header: translate("leistungsbeschreibung_kurz"),
    },
    {
      accessorKey: "leistungsbeschreibung_lang",
      header: translate("leistungsbeschreibung_lang"),
    },
    {
      accessorKey: "menge",
      header: translate("menge"),
    },
    {
      accessorKey: "mappedMengeneinheit",
      header: translate("mengeneinheit"),
    },
    {
      accessorKey: "anzahl",
      header: translate("anzahl"),
    },
    {
      accessorKey: "preis_1",
      header: translate("preis_1"),
    },
    {
      accessorKey: "preis_2",
      header: translate("preis_2"),
    },
    {
      accessorKey: "preis_3",
      header: translate("preis_3"),
    },
    {
      accessorKey: "preis_4",
      header: translate("preis_4"),
    },
    {
      accessorKey: "mappedKostenstelle",
      header: translate("kostenstelle"),
    },
    {
      accessorKey: "_id",
      header: translate("optionen"),
      enableHiding: false,
      Cell: ({ cell }) => (
        <Link
          to={`/services/edit/${cell.getValue()}`}
          className="whitespace-nowrap inline-flex items-center justify-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
            />
          </svg>
        </Link>
      ),
    },
  ];

  const columns = useMemo(
    () =>
      allColumns.filter(function (el) {
        return activatedFields.includes(el.accessorKey);
      }),
    [activatedFields]
  );

  let table = useMaterialReactTable({
    columns,
    data: services,
    localization: MRT_Localization_DE,
    enableColumnOrdering: true,
    enableGlobalFilter: true,
    enableGrouping: true,
  });

  useEffect(() => {
    getServices();
  }, [userData]);

  return (
    <>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg flex justify-between">
        <div className="px-4 py-5 sm:px-6 justify-start lg:w-0 lg:flex-1">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            {translate("Leistung_ueberschrift")}
          </h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">
            {translate("Leistung_ueberschrift2")}
          </p>
        </div>
        <div className="px-4 py-5 sm:px-6 flex justify-end md:flex-1 lg:w-0">
          {userData && userData.permissions.isAdmin && (
            <Link
              to="/services/new"
              className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              {translate("Leistung_hinzufuegen")}
            </Link>
          )}
        </div>
      </div>
      <div className="bg-white w-full  shadow overflow-auto sm:rounded-lg flex justify-between my-5 border-b border-gray-200 shadow  w-full sm:rounded-lg"></div>
      <MaterialReactTable table={table} />
    </>
  );
}
